import React, {useState, useEffect} from 'react';
import '../../assets/scss/v0/WishesForm.scss';
import styles from '../../assets/scss/v0/WishesForm.module.scss';
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, Navigation, Zoom} from "swiper/modules";
import quoteLeft from '../../assets/images/qouteleft.png';
import quoteRight from '../../assets/images/qouteright.png';
import WeddingService from "../../services/WeddingService";
import Modal from "react-modal";
import useWindowSize from "../../hooks/useWindowSize";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

const WishesForm = () => {
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');
    const [wishes, setWishes] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const windowSize = useWindowSize();

    useEffect(() => {
        getAllWish();
    }, []);

    const getAllWish = () => {
        WeddingService.getAllWish()
            .then(response => {
                if (200 === response.status && response.data) {
                    const data = response.data;
                    if (Array.isArray(data)) {
                        const dataList = [];
                        data.forEach((item, index) => {
                            if (item.desc && item.value) {
                                const itemWish = {
                                    name: item.desc,
                                    message: item.value
                                };
                                dataList.push(itemWish);
                            }
                        });

                        setWishes(dataList);
                    }
                }
            })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name && message) {
            const newWish = {
                value: message,
                desc: name,
                unit: 'wedding',
                enable: true
            };

            WeddingService.saveWish(newWish)
                .then(response => {
                    if (200 === response.status) {
                        setName('');
                        setMessage('');
                        getAllWish();
                        setModalIsOpen(false);
                    }
                })

        }
    };

    const closeModal = () => setModalIsOpen(false);
    const openModal = () => setModalIsOpen(true);

    return (

        <>
            <div style={{width:'100%',textAlign:'center',marginTop: '20px'}}>
                <button className={styles.btnSentWish} type="submit" onClick={openModal}>Gửi Lời Chúc</button>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                style = {{
                    overlay: {
                        backgroundColor: 'rgba(0, 0, 0, 0.75)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    },
                    content: {
                        position: 'relative',
                        width: windowSize.width < 768 ? '100%' : '70%',
                        maxWidth: '800px', // Thêm maxWidth nếu bạn muốn giới hạn kích thước tối đa
                        inset: 'auto', // Ghi đè các giá trị top, left, right, bottom mặc định
                        margin: '0 auto',
                        padding: '20px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        background: '#fff',
                        overflow: 'auto'
                    }
                }}
            >
                <form onSubmit={handleSubmit} className={styles.wishesForm}>
                    <div style={{
                        width: '100%',
                        textAlign: 'center',
                        color: '#2a432d',
                        marginBottom: '10px',
                        fontSize: '1.4rem',
                        fontWeight: '600',
                        fontFamily: '"Bodoni", serif'
                    }}>
                        Gửi Lời Chúc
                    </div>
                    <input
                        style={{fontFamily: '"Bodoni", serif',fontSize:'1rem'}}
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Tên của bạn"
                        required
                    />
                    <textarea
                        style={{fontFamily: '"Bodoni", serif',fontSize:'1rem'}}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Lời chúc của bạn"
                        required
                    />
                    <button onClick={closeModal} style={{position: 'absolute', right: '10px', top: '10px', background: 'none', border: 'none', color: '#2a432d', fontSize: '2rem', cursor:'pointer'}}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                    <button type="submit">Gửi Lời Chúc</button>
                </form>
            </Modal>

            <div className={styles.wishesContainer}>

                <Swiper
                    // centeredSlides={true}
                    zoom={true}
                    slidesPerView={1}
                    spaceBetween={80}
                    loop={true}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[Navigation, Zoom,Autoplay]}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    effect="coverflow"
                    coverflowEffect={{
                        rotate: 0,
                        stretch: 0,
                        depth: 100,
                        modifier: 2,
                        slideShadows: false,
                    }}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                    }}
                    className="wishesList"
                >
                    {wishes.map((wish, index) => (
                        <SwiperSlide key={index}>
                            <div key={index} className={styles.wishItem}>
                                <div className={styles.quoteLeft}>
                                    <img src={quoteLeft} alt="quoteLeft"/>
                                </div>
                                <div className={styles.contentWish}>
                                    <strong>{wish.name}</strong>
                                    <p>{wish.message}</p>
                                </div>

                                <div className={styles.quoteRight}>
                                    <img src={quoteRight} alt="quoteRight"/>
                                </div>

                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev"></div>
                    <div className="swiper-button-next"></div>
                </Swiper>
            </div>
        </>

    );
};

export default WishesForm;